import { FilmPageContext } from 'context/FilmPageContext';
import { useContext } from 'react';

const useMenuVariants = () => {
  const { state } = useContext(FilmPageContext);
  return state.menuOpen ? 'open' : 'hidden';
};

export default useMenuVariants;
